import { Component, OnInit, ViewEncapsulation, Inject } from "@angular/core";

@Component({
  selector: "c-head",
  templateUrl: "./c-head.component.html",
  styleUrls: ["./c-head.component.css"],
  encapsulation: ViewEncapsulation.None
})
export class CHeadComponent implements OnInit {
  constructor() {}
  ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/c-head/c-head.component.ts